// src/pages/departments/DepartmentsPage/components/ModulesManagementDialog.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
} from '@mui/material';
import {
  Extension as ExtensionIcon,
} from '@mui/icons-material';

export default function ModulesManagementDialog({
  open,
  onClose,
  department,
  assignedModules,
  allModules,
  onModuleToggle,
  canEnable = true,
  canDisable = true,
  loading,
}) {
  const { t } = useTranslation(["departments"]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {t('departments:modules.dialog_title', { name: department?.name })}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" paragraph>
          {t('departments:modules.dialog_subtitle')}
        </Typography>
        
        <List>
          {allModules.map((module) => {
            const isAssigned = assignedModules.some(
              am => am.module_id === module.module_id
            );
            
            return (
              <ListItem key={module.module_id} divider>
                <ListItemIcon>
                  <ExtensionIcon color={isAssigned ? 'primary' : 'disabled'} />
                </ListItemIcon>
                <ListItemText
                  primary={module.name}
                  secondary={module.description}
                />
                <ListItemSecondaryAction>
                  <Switch
                    checked={isAssigned}
                    onChange={() => onModuleToggle(department, module, isAssigned)}
                    disabled={loading || !(isAssigned ? canDisable : canEnable)}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('departments:modules.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}